<h2 *ngIf="title" class="accent-text-color" mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content style="overflow: hidden">
  <p class="mat-body-2">{{ message }}</p>
</div>
<div fxLayout="row" fxLayoutAlign="end center" mat-dialog-actions>
  <button [mat-dialog-close]="true" color="primary" mat-button>
    Understood
  </button>
</div>
